import { Search } from "lucide-react"

import { ProjectSelectionOverlay } from "@/components/overlays/ProjectSelectionOverlay"
import { Button } from "@ui/button"

import { DynamicColumn } from "@/models/datatable"
import { FilterLogic, FilterProperty } from "@/models/facets"
import { ReportSearchField } from "@/models/report"

import { CollectionItem, ContentObjectItem } from "@vertesia/common"

interface ReportDocumentSelectionProps {
    more?: boolean
    configuration: CollectionItem
    handleDocumentSelection: (documents: ContentObjectItem[]) => void
}
export function ReportDocumentSelection({ more = false, configuration, handleDocumentSelection }: Readonly<ReportDocumentSelectionProps>) {
    const types = retrieveTypes(configuration)
    const searches = retrieveSearches(configuration)
    const filters = retrieveFilters(configuration)
    const columns = retrieveColumns(configuration)
    const filters_logic = retrieveFiltersLogic(configuration)

    return (
        <ProjectSelectionOverlay types={types} searches={searches} filters={filters} columns={columns} filters_logic={filters_logic} onObjMultipleSelection={handleDocumentSelection}>
            <Button>
                <Search />
                { 
                    (more) ? (
                        "Add More"
                    ) : (
                        "Search Documents"
                    )
                }
            </Button>
        </ProjectSelectionOverlay>
    )
}

function retrieveTypes(configuration: CollectionItem): string[] {
    const properties = (configuration as any)?.properties
    if (!properties || !properties.types) {
        return []
    }

    return properties.types?.filter((type: any) => type.id !== "all").map((type: any) => type.id) || []
}

function retrieveFilters(configuration: CollectionItem): FilterProperty[] {
    const properties = (configuration as any)?.properties
    if (!properties || !properties.filters) {
        return []
    }
    return properties.filters
}

function retrieveSearches(configuration: CollectionItem): ReportSearchField[] {
    const properties = (configuration as any)?.properties
    if (!properties || !properties.search) {
        return []
    }
    return properties.search
}

function retrieveColumns(configuration: CollectionItem): DynamicColumn[] {
    const properties = (configuration as any)?.properties
    if (!properties || !properties.columns) {
        return []
    }
    return properties.columns
}

function retrieveFiltersLogic(configuration: CollectionItem): FilterLogic[] {
    const properties = (configuration as any)?.properties
    if (!properties || !properties.filters_logic) {
        return []
    }
    return properties.filters_logic
}